import React from 'react'
import { CircularProgress, Grid, TextField } from '@material-ui/core'
import { maxLength } from 'utils/helpers'
import useStyles from './styles'

export const DadosVeiculo = (props) => {
  const classes = useStyles()
  const { carregando, form } = props

  const toUpperCase = (newValue) => {
    let result = newValue.toUpperCase()
    result = maxLength(result, 7)
    return result
  }

  const maxMarcaModelo = (newValue) => maxLength(newValue, 20)

  const maxDescricao = (newValue) => maxLength(newValue, 250)

  return (
    <div>
      {carregando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container className={classes.fieldGroup}>
          <Grid item md={2} sm={12} xs={12} className={classes.item}>
            <TextField
              label="Placa"
              name="placa"
              minRows={1}
              fullWidth
              value={form.formState.values.placa}
              onChange={(e) => form.handleChangeWithModification(e, toUpperCase)}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={5} sm={12} xs={12} className={classes.item}>
            <TextField
              label="Marca"
              minRows={1}
              fullWidth
              name="marca"
              value={form.formState.values.marca}
              onChange={(e) => form.handleChangeWithModification(e, maxMarcaModelo)}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={5} sm={12} xs={12} className={classes.item}>
            <TextField
              label="Modelo"
              name="modelo"
              minRows={1}
              fullWidth
              value={form.formState.values.modelo}
              onChange={(e) => form.handleChangeWithModification(e, maxMarcaModelo)}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={12} sm={12} xs={12} className={classes.fieldDescricao}>
            {/* <Typography className={classes.tituloCampo}>Descrição Geral</Typography> */}
            <TextField
              label="Descrição Geral"
              minRows={5}
              name="descricao"
              fullWidth
              multiline
              value={form.formState.values.descricao}
              onChange={(e) => form.handleChangeWithModification(e, maxDescricao)}
              error={form.hasError('descricao')}
              helperText={form.hasError('descricao') ? form.formState.errors.descricao[0] : null}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      )}
    </div>
  )
}
